import { InjectionToken } from '@angular/core';

import type { DoodProductModel } from '@core/models/product.model';
import type { KioskProductAddPagePreviewShop } from '@front-platform/content-builder';

/** Runtime payload consumed by the kiosk product add page preview datasource. */
export type KioskProductAddPageViewModel = {
  shopId: string;
  productId: string;
  product: DoodProductModel;
  shop: KioskProductAddPagePreviewShop;
};

export interface KioskProductAddPageDataSource {
  readonly vm$: import('rxjs').Observable<KioskProductAddPageViewModel | null>;
}

export const KIOSK_PRODUCT_ADD_PAGE_DATA_SOURCE = new InjectionToken<KioskProductAddPageDataSource>(
  'KIOSK_PRODUCT_ADD_PAGE_DATA_SOURCE',
);
